var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDbIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.07,80l36.46-36.46c1.95-1.95,1.95-5.12,0-7.07-1.95-1.95-5.12-1.95-7.07,0l-36.46,36.46-36.46-36.46c-1.95-1.95-5.12-1.95-7.07,0-1.95,1.95-1.95,5.12,0,7.07l36.46,36.46-36.46,36.46c-1.95,1.95-1.95,5.12,0,7.07.98.98,2.26,1.46,3.54,1.46s2.56-.49,3.54-1.46l36.46-36.46,36.46,36.46c.98.98,2.26,1.46,3.54,1.46s2.56-.49,3.54-1.46c1.95-1.95,1.95-5.12,0-7.07l-36.46-36.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbIconClose);
export default __webpack_public_path__ + "static/media/db_icon_close.8efb957f8f1a021e9e9af1c27ed53aeb.svg";
export { ForwardRef as ReactComponent };